// extracted by mini-css-extract-plugin
export default {"firstJobEmptyTitle":"styles_firstJobEmptyTitle__0XV7S","firstJobEmptySubtitle":"styles_firstJobEmptySubtitle__i8tkm"};